module.exports = __webpack_public_path__ + "img/swiper3.a87acfe7.png";